import { useAuth } from "../../../permissions/useAuth";
import { canUseAdminCopilot } from "../../../permissions/adminCopilotAccess";
import { useAppSelector } from "../../../redux/hooks";
import AdminCopilotPanel from "./AdminCopilotPanel";

export default function AdminCopilotRuntime() {
  const { isCompanyPrincipal, roleType, permissions, isAuthenticated } = useAuth();
  const tenantId = useAppSelector((state) => state.company.id);
  const adminAiAssistantEnabled = useAppSelector(
    (state) => state.company.adminAiAssistantEnabled,
  );
  if (
    !canUseAdminCopilot({
      isAuthenticated,
      tenantId,
      isCompanyPrincipal,
      roleType,
      permissions,
      adminAiAssistantEnabled,
    }) ||
    !tenantId
  ) {
    return null;
  }
  return <AdminCopilotPanel tenantId={tenantId} />;
}
